/**
 * Desktop sticky ATC bar — appears when main buy-buttons block scrolls out of
 * viewport. Delegates the actual add-to-cart click to the main ATC button so
 * the theme's existing cart-drawer flow fires unchanged.
 */
(function () {
  if (window.matchMedia('(max-width: 980px)').matches) return;

  const bar = document.querySelector('[data-pdp-desktop-atc]');
  if (!bar) return;

  const mainBuy =
    document.querySelector('.product-single__box__block--buy_buttons') ||
    document.querySelector('.product-form__cart-submit') ||
    document.querySelector('[name="add"]');
  if (!mainBuy) return;

  const submitBtn = bar.querySelector('[data-pdp-desktop-atc-submit]');
  const selectBtn = bar.querySelector('[data-pdp-desktop-atc-select]');
  const label = bar.querySelector('[data-pdp-desktop-atc-label]');
  const priceEl = bar.querySelector('[data-pdp-desktop-atc-price]');
  const colorNameEl = bar.querySelector('[data-pdp-desktop-atc-color-name]');
  const sizeEl = bar.querySelector('[data-pdp-desktop-atc-size]');
  const imgEl = bar.querySelector('[data-pdp-desktop-atc-img]');
  const formId = submitBtn.getAttribute('data-form-id');
  const form = document.getElementById(formId);

  // Visibility — show when main ATC is OUT of view
  const observer = new IntersectionObserver(
    function (entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    },
    { threshold: 0.05 }
  );
  observer.observe(mainBuy);

  // Sync from the product form (variant changes, sold out states, etc.)
  function syncBar() {
    if (!form) return;
    const checked = form.querySelector('input[name="id"]:checked');
    const select = form.querySelector('select[name="id"]');
    const hidden = form.querySelector('input[name="id"]');
    const variantId = (checked && checked.value) || (select && select.value) || (hidden && hidden.value);
    if (!variantId) return;

    // Read variant info from product JSON if available
    if (!window.__rsr_product_data) {
      const handle = location.pathname.match(/\/products\/([^/?#]+)/);
      if (handle) {
        fetch('/products/' + handle[1] + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            window.__rsr_product_data = data;
            applyVariant(variantId);
          })
          .catch(function () {});
      }
    } else {
      applyVariant(variantId);
    }
  }

  function applyVariant(variantId) {
    const data = window.__rsr_product_data;
    if (!data) return;
    const variant = data.variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    // Update price
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // Update color name (if product has color option)
    if (colorNameEl) {
      const colorOptionIndex = (data.options || []).findIndex(function (o) {
        return String(o).toLowerCase() === 'color' || String(o).toLowerCase() === 'colour';
      });
      if (colorOptionIndex >= 0) {
        const colorVal = variant.options[colorOptionIndex];
        colorNameEl.textContent = '/ ' + colorVal;
      }
    }

    // Update size — the bar should always say which size you're getting
    if (sizeEl) {
      const sizeOptionIndex = (data.options || []).findIndex(function (o) {
        return String(o).toLowerCase() === 'size';
      });
      sizeEl.textContent = sizeOptionIndex >= 0 ? '/ ' + variant.options[sizeOptionIndex] : '';
    }

    // Update image
    if (imgEl && variant.featured_image && variant.featured_image.src) {
      imgEl.src = sized(variant.featured_image.src, 120);
    }

    // Sold out -> Select size if no size, or Notify when back if size picked
    if (label) {
      if (!variant.available) {
        submitBtn.disabled = true;
        label.textContent = 'Sold out';
      } else {
        submitBtn.disabled = false;
        label.textContent = 'Add to cart';
      }
    }

    // Hide "Select size" once a real variant (not the first default) is chosen
    if (selectBtn) {
      const hasSizeOption = (data.options || []).some(function (o) {
        return String(o).toLowerCase() === 'size';
      });
      if (hasSizeOption) {
        selectBtn.hidden = false; // always show as quick scroll-to-size link
      } else {
        selectBtn.hidden = true;
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/, '_' + w + 'x$1$3');
  }

  // Submit: programmatically click main ATC so theme flow runs — with
  // visible confirmation once the cart actually updates.
  submitBtn.addEventListener('click', function () {
    const mainAtc =
      (form && form.querySelector('.product-form__cart-submit')) ||
      (form && form.querySelector('[name="add"]')) ||
      mainBuy;
    if (!mainAtc) return;
    if (label) label.textContent = 'Adding\u2026';
    submitBtn.disabled = true;
    function confirmAdd() {
      if (label) label.textContent = 'Added \u2713';
      submitBtn.style.background = '#2e6b34';
      submitBtn.style.borderColor = '#2e6b34';
      submitBtn.style.color = '#fff';
      setTimeout(function () {
        submitBtn.style.background = '';
        submitBtn.style.borderColor = '';
        submitBtn.style.color = '';
        submitBtn.disabled = false;
        syncBar();
      }, 2400);
    }
    if (window.jQuery) {
      window.jQuery(document.body).one('afterCartLoad.ajaxCart', confirmAdd);
      /* safety: if no cart event fires (validation error), restore */
      setTimeout(function () {
        if (submitBtn.disabled && label && label.textContent === 'Adding\u2026') {
          submitBtn.disabled = false;
          syncBar();
        }
      }, 5000);
    } else {
      setTimeout(confirmAdd, 900);
    }
    mainAtc.click();
  });

  // "Select size" scrolls to the size selector
  if (selectBtn) {
    selectBtn.addEventListener('click', function () {
      const sizeBlock =
        document.querySelector('.product-single__box__block--variant_picker') ||
        document.querySelector('.product-form__option');
      if (sizeBlock) {
        sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // Watch form for changes — poll fallback for the same reason as gallery sync
  let lastVariantId = null;
  setInterval(function () {
    if (!form) return;
    const checked = form.querySelector('input[name="id"]:checked');
    const select = form.querySelector('select[name="id"]');
    const hidden = form.querySelector('input[name="id"]');
    const variantId = (checked && checked.value) || (select && select.value) || (hidden && hidden.value);
    if (variantId && variantId !== lastVariantId) {
      lastVariantId = variantId;
      syncBar();
    }
  }, 200);

  // Initial sync
  syncBar();
})();
